import { CartInfoType, CartSubCartsLinesType } from "@src/utils/types";
import { checkout } from "@components/pages/CheckoutPage/__generated__/checkout";
import { checkoutUpdate_checkoutUpdate_checkout_subcarts_lines } from "@components/pages/CheckoutPage/__generated__/checkoutUpdate";

// freebie, notFreebie 분리
export const separateFreebieAndNotFreebieLines = <
  T extends CartSubCartsLinesType | checkoutUpdate_checkoutUpdate_checkout_subcarts_lines
>(
  cart: CartInfoType | checkout
) => {
  let freebies: (T | null)[] = [];
  let notFreebies: (T | null)[][] = [];

  cart?.subcarts?.forEach((subcart, i) => {
    notFreebies.push([]);
    (subcart.lines as T[]).forEach((line) => {
      line.isFreebie ? freebies.push(line) : notFreebies[i].push(line);
    });
  });

  return { freebies, notFreebies };
};

// not freebie들의 checked 상태(boolean) 배열 추출
export const extractCheckedStatesOfNotFreebies = (notFreebies: (CartSubCartsLinesType | null)[][]) => {
  const checkedStatesOfNotFreebies = notFreebies.map(notFreebie =>
    notFreebie ? notFreebie.map(line => line?.selected) : []
  );

  return checkedStatesOfNotFreebies;
};
